import React, { useState, useMemo, useEffect } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { toast } from 'react-toastify';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
// import Swal from 'sweetalert2';
import moment from 'moment';
import useStore from '../../states/store';
import TabPanel from '../../components/TabPanel';
import Filter from './components/Filter';
import Table from './components/Table';
import usePRDcontext from './context/usePRDcontext';
import { DashboardProvider } from '../Dashboard/useDashboard';
import { getPrdDashboardList } from '../../api/prdDashboardApi';

export default function PRDDashboard() {
  const auth = useStore((state) => state.auth);

  const defaultFilter = {
    team: [{ label: 'ALL', value: null }],
    regional_manager_id: [{ label: 'ALL', value: null }],
    manager_id: [{ label: 'ALL', value: null }],
    rep_id: [{ label: 'ALL', value: null }],
    md_id: [{ label: 'ALL', value: null }],
    year: moment().endOf('month').format('YYYY'),
  };

  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [filterForm, setFilterForm] = useState(defaultFilter);
  const [clearFilter, setClearFilter] = useState(true);
  const [dashboardData, setDashboardData] = useState([]);

  const handleChangeActiveTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleGenerateReport = async () => {
    try {
      setLoading(true);

      const statusType = {
        regional_manager_id:
          filterForm?.regional_manager_id[0].value !== null
            ? filterForm?.regional_manager_id?.map((row) => row.label)
            : [],
        district_manager_id:
          filterForm?.manager_id[0].value !== null
            ? filterForm?.manager_id?.map((row) => row.label)
            : [],
        med_rep_id:
          filterForm?.rep_id[0].value !== null ? filterForm?.rep_id?.map((row) => row.label) : [],
        md_id:
          filterForm?.md_id[0].value !== null ? filterForm?.md_id?.map((row) => row.value) : [],
        year: filterForm?.year,
      };
      const response = await getPrdDashboardList(statusType);
      const { success, data } = response.data;

      if (success) {
        // const newIds = data[0].map((row) => row.id);
        setDashboardData(data);
      }

      setLoading(false);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleClearReport = () => {
    setFilterForm(defaultFilter);
    setClearFilter(false);
  };

  useEffect(() => {
    setClearFilter(true);
    handleGenerateReport();
  }, [clearFilter]);
  return (
    <DashboardProvider>
      <usePRDcontext.Provider
        value={useMemo(
          () => ({
            auth,
            loading,
            dashboardData,
            filterForm,
            clearFilter,
            setFilterForm,
            setLoading,
            handleGenerateReport,
            handleClearReport,
          }),
          [loading, filterForm, dashboardData],
        )}
      >
        <Box sx={{ backgroundColor: '#fff', p: 1, boxShadow: 3 }}>
          <Filter />
        </Box>
        <Box padding={4}>
          <Box>
            <Box>
              <Grid container spacing={2}>
                <Grid xs={12} sm={12} md={12}>
                  <Box sx={{ backgroundColor: '#fff' }} mt={4}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <Tabs
                        value={activeTab}
                        onChange={handleChangeActiveTab}
                        aria-label='basic tabs example'
                      >
                        <Tab
                          label='PRD Dashboard List'
                          id='prd-dashboard-list'
                          aria-controls='prd-dashboard-list'
                        />
                      </Tabs>
                    </Box>
                    <TabPanel value={activeTab} index={activeTab}>
                      <Table />
                    </TabPanel>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </usePRDcontext.Provider>
    </DashboardProvider>
  );
}
